import { tv } from 'tailwind-variants'

import { body2, caption } from '@ui-kit/core/typography'

export const tableContent = tv({
  slots: {
    row: 'flex flex-row flex-wrap items-center gap-2.5 p-4 md:gap-8',
    titleContainer: 'flex w-full flex-col gap-y-2.5 pb-6 md:w-[375px]',
    descriptionTitleContainer:
      'flex flex-row items-center gap-x-2.5 hover:opacity-70 active:opacity-70 web:transition web:duration-300',
    descriptionTitle: body2({ bold: true }),
    description: caption(),
    value: 'flex flex-1 flex-row items-center justify-center self-start',
  },
  variants: {
    isFirst: {
      true: {
        row: 'border-t-0',
      },
      false: {
        row: 'border-t border-solid border-t-grey-300',
      },
    },
  },
})
